"use client";
import React from "react";
import { motion } from "framer-motion";

const StorySection = () => {
  return (
    <motion.section
      className="flex overflow-hidden flex-col items-center w-full bg-orange-100  "
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      aria-labelledby="story-title"
    >
      {/* Section Divider */}
        <motion.img
            src="https://api.builder.io/api/v1/image/assets/TEMP/b70ed3145242d5de746760efaf735e368dd08f66?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
            alt="Decorative border"
            className="object-cover w-full h-[40px] md:h-[60px] lg:h-[80px] mb-16 [filter:brightness(0)_saturate(100%)_invert(100%)]"
            style={{ objectPosition: 'center' }}
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
        />


      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <motion.h2
          id="story-title"
          className="text-4xl md:text-6xl font-semibold text-cyan-900 text-center mb-12"
          style={{ fontFamily: "'Sansita Swashed', cursive" }}
          initial={{ scale: 0.8, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Know Us Better
        </motion.h2>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left Content - Story */}
          <motion.div
            className="flex-1 text-center lg:text-left"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <motion.h3
              className="text-3xl md:text-4xl font-semibold text-red-500 mb-6"
              style={{ fontFamily: "'Sansita Swashed', cursive" }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              viewport={{ once: true }}
            >
              Welcome to Iyna Cakes & Desserts!
            </motion.h3>

            <motion.p
              className="text-lg md:text-xl text-cyan-900 leading-relaxed mb-6"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              viewport={{ once: true }}
            >
              Maria, a Roman-born pastry chef, has spent over 15 years in the heart of Rome
              perfecting her artistry in baking. Her journey began in small Roman kitchens,
              where passion met precision.
            </motion.p>

            <motion.p
              className="text-lg md:text-xl text-cyan-900 leading-relaxed"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.0 }}
              viewport={{ once: true }}
            >
              Through years of dedication, creativity, and love for the craft, she developed
              a signature style that blends traditional Italian techniques with modern elegance.
            </motion.p>
          </motion.div>

          {/* Right Content - Image/Visual */}
          <motion.div
            className="flex-1 flex justify-center lg:justify-end"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <div className="relative">
              <motion.div
                className="w-80 h-80 bg-gradient-to-br from-orange-200 to-red-200 rounded-full flex items-center justify-center"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <div className="text-8xl">👩‍🍳</div>
              </motion.div>

              {/* Decorative elements */}
              <motion.div
                className="absolute -top-4 -right-4 text-4xl"
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
              >
                🌟
              </motion.div>
              <motion.div
                className="absolute -bottom-4 -left-4 text-4xl"
                animate={{ rotate: -360 }}
                transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
              >
                🍰
              </motion.div>
              <motion.div
                className="absolute top-1/2 -left-8 text-3xl"
                animate={{ y: [-10, 10, -10] }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
              >
                ✨
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Section Divider */}
      <motion.img
        src="https://api.builder.io/api/v1/image/assets/TEMP/023c7e32def6b238884f943b06ac68d961fd306e?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
        alt="Section divider"
        className="object-cover mt-16 w-full h-[40px] md:h-[60px] lg:h-[80px]"
        style={{ objectPosition: 'center' }}
        initial={{ scale: 0.8, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6, delay: 1.2 }}
        viewport={{ once: true }}
      />
    </motion.section>
  );
};

export default StorySection;
